import api from '@/api/axios'

export const getBanners = async () => {
  const response = await api.get(`/banners/all`)
  return response.data
}

export const getBannerDetailsBySlug = async (slug) => {
  const response = await api.get(`/banners/details/${slug}`)
  return response.data
}